import { HttpUtils } from '../common/http/HttpUtils';
import { WlMasterDataRequest } from './service-models/wl-master/WlMasterDataRequest';
import { WlMasterDataResult } from './service-models/wl-master/WlMasterDataResult';
import { BaseService } from './BaseService';
import { WprBaseViewCore } from '../wpr-framework/view/WprBaseViewCore';

/**
 * システムサービス
 */
export class SystemService extends BaseService {
	// サービス メソッド  -----------------------------------------------------------------------------------------------------------------------------
	/**
	 * 告知事項検索
	 * @param viewCore ビュー情報
	 * @param request リクエスト情報
	 * @param resMethod 結果処理メソッド
	 */
	public getSystemCache(viewCore: WprBaseViewCore, request: WlMasterDataRequest, resMethod: (result: WlMasterDataResult) => void): void {
		return this.doPost(viewCore, '/system/cache', request, resMethod);
	}

	public finish(viewCore: WprBaseViewCore): void {
		return this.doPost(viewCore, '/finish', null, null);
	}

	public async getNoticeXml(url: string): Promise<any> {
		return await HttpUtils.doGetXmlFile(url);
	}
	// -----------------------------------------------------------------------------------------------------------------------------------------------
}